import { TemplatePage } from './types';

const memesPage: TemplatePage = {
  header: {
    color: '#FAA6B5',
    icon: 'images/video-templates/memes.jpg',
    title: 'Editable Meme Templates',
    title_meta: '50+ Free Editable Meme Templates',
    description_meta:
      'Create your own shareworthy memes with our wide range of easy-to-customize free meme templates.',
    description:
      'Create your own shareworthy memes with our wide range of easy-to-customize free meme templates. ' +
      'Pick a meme template of your choice, customize it with your caption, and download the result as a video, ' +
      'image, or GIF.'
  },
  footer: {
    category: 'memes',
    description:
      'Thanks to the dozens of free customizable meme templates, creating viral content with Wave.video is a ' +
      'breeze even for newbies with no design or editing skills. Easily make memes that will attract the attention of ' +
      'your target audience in no time.'
  },
  content: [
    {
      type: 'templates',
      title: 'Memes Video ',
      search: { name: 'meme', tags: 'meme' }
    },
    {
      type: 'stocks',
      title: 'memes',
      search: { name: 'memes' }
    },
    { type: 'calendar' }
  ]
};

export default memesPage;
